import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./styles.scss";
import _ from "lodash";
import { Toast } from "../../../components";
import usePaystackHook from "../../../components/Payment";
import { CircularProgress } from "@material-ui/core";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import HomeDisable from "../../../assets/images/HomeDisable.svg";
import DisableRight from "../../../assets/images/DisableRight.svg";
import LeftNav from "../../../assets/images/left.svg";
import Rightnav from "../../../assets/images/rightNav.svg";
import DownYellow from "../../../assets/images/downYellow.svg";
import CheckoutSuccess from "./components/SucessPopup/checkoutSuccessPop";
import Layout from "../../../layout";
import { useHistory } from "react-router-dom";
import axios from "../../../redux/axios";
import { set } from "lodash";
import { clearTest } from "../../../redux/auth/actions";
import ShoppingCartLabWise from "./ShoppingCartLabWise";
import ShoppingCartPackageLabWise from "./ShoppingCartPackageLabWise";
import { clearCart, getCartItems } from "../../../redux/cart/CartAction";
import LoaderComponent from "../../../components/Loading/LoaderComponent";
import ApplyPromoCode from "./ApplyPromoCode";
import { Helmet } from "react-helmet";
import { getFirebaseAnalyticsInstance } from "../../../firebase";
import ReactGA from 'react-ga';

const ShoppingCart = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  let stateData = history.location.state;
  const savedArea = useSelector((state) => state.area);
  const savedCity = useSelector((state) => state.city);

  const cartState = useSelector((state) => state.cartsData);
  const [homeAddres, setHomeAddress] = useState("");
  const [homeSerivceData, setHomeServiceData] = useState([]);
  const [recipientArray, setRescipientArray] = useState([]);
  const [data, setData] = useState([{ id: "111" }]);
  const [shoppingCart, setShoppingCart] = useState([]);
  const [homeService, setHomeService] = useState([]);
  const [cartUuid, setCartUuid] = useState("");
  const [nphone, setNphone] = useState();
  const [country, setCountry] = useState("");

  const [delivery, setDelivery] = useState([]);
  const cityList = useSelector((state) => state.auth.cities);
  const areaList = useSelector((state) => state.auth.areas);
  const user = useSelector((state) => state.auth);
  const [modalShow, setModalShow] = useState(false);
  const [openPopup, setOpenPop] = useState(false);
  const [mobileView, setMobileView] = useState(false);
  const [showSummary, setShowSummary] = useState(false);
  const [radiovalue, setRadiovalue] = useState([]);
  const [seletall, setSelectall] = useState(false);
  const [successName, setSuccessName] = useState("");
  const [successPop, setSuccessPop] = useState(false);
  const [isPackageCart, setIsPackageCart] = useState(false);
  // const paymentStart = usePaystackHook();
  const [reference, setReference] = useState("");
  const [showHomeService, setShowHomeService] = useState(false);
  const [testItem, setTestItem] = React.useState([]);
  const [errorPop, setErrorPop] = useState(false);
  const [errName, setErrName] = useState("");
  const [cartAmount, setCartAmount] = useState(0);
  const [discountedAmount, setDiscountedAmount] = useState(0);
  const [cartCuuid, setCartCuuid] = useState("");
  const [qtyValue, setQtyValue] = useState([]);
  const [showRecipient, setShowRecipient] = useState(false);
  const [selectRecipient, setSelectRecipient] = useState([]);
  const [edit, setEdit] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [promoCodeVisibility, setPromoCodeVisibility] = useState(false);
  const [appliedCoupanId, setAppliedCoupanId] = useState("");
  const [couponAppliedFlag, setCouponsAppliedFlag] = useState(false);
  const [copuponsLoader, setCopuponsLoader] = useState(false);

  const [walletCodeVisibility, setwalletCodeVisibility] = useState(false);
  const [walletFlag, setwalletFlag] = useState(false);
  const [walletamount, setwalletAmount] = useState("");
  const [useAmount, setUseamount] = useState(0);
  const [showPopup, setShowPopup] = useState(false);

  const handleButtonClick = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };
  const user_id = useSelector((state) => state.auth.uuid);

  const paymentStart = usePaystackHook({
    email: user.email,
    amt:
      (couponAppliedFlag || walletFlag) &&
        discountedAmount &&
        discountedAmount !== null &&
        discountedAmount !== "" &&
        discountedAmount !== undefined &&
        discountedAmount > 0
        ? parseInt(discountedAmount)
        : parseInt(cartAmount),
  });

  const [editForm, setEditForm] = useState({
    address: "",
    city: "",
    area: "",
    postCode: "",
    phone: "",
    email: "",
    recipient: "",
    uuid: "",
  });
  const [addressForm, setAddressForm] = useState([
    {
      address: "",
      city: "",
      area: "",
      postCode: "",
      phone: "",
      email: "",
      recipient: "",
    },
  ]);

  const [datatwo, setDatatwo] = useState([
    { id: "11", val: "11" },
    { id: "22", val: "22" },
    { id: "33", val: "3" },
  ]);
  const [totalRecipient, setTotalRecipient] = useState([
    {
      id: "11",
      name: "Mrs. Promise Akintunde",
    },
    {
      id: "22",
      name: "Andrew Akintunde",
    },
  ]);

  const cityState = useSelector((state) =>
    state.city != undefined && state.city.label != undefined ? state.city : ""
  );
  const areaState = useSelector((state) =>
    state.area != undefined && state.area.area != undefined
      ? state.area.area
      : ""
  );

  React.useEffect(() => {
    dispatch(getCartItems());
  }, []);

  React.useEffect(() => {
    window.scrollTo(0, 100);
    setCartAmount(0);
  }, []);

  useEffect(() => {
    setRadiovalue([]);
    Getwallet();
  }, []);

  useEffect(() => {
    cartFetch();
    setRadiovalue([]);
  }, [cartState]);

  if (walletFlag === true || couponAppliedFlag === true) {
    const detail = {
      user: user_id,
      Amount: discountedAmount,
      location: cityState, areaState
    }
    // getFirebaseAnalyticsInstance().logEvent('Order Details',detail)
    ReactGA.event({
      category: 'Order Details',
      action: detail,
      label: 'Order Details',
    })
  }
  else {
    const detail = {
      user: user_id,
      Amount: discountedAmount,
      location: cityState, areaState
    }
    // getFirebaseAnalyticsInstance().logEvent('Order Details',detail)
    ReactGA.event({
      category: 'Order Details',
      action: detail,
      label: 'Order Details',
    })

  }

  const blockAppliedCoupon = async (transactionId) => {
    if (appliedCoupanId && appliedCoupanId !== "") {
      try {
        let response = await axios.put(
          `${process.env.REACT_APP_API_URL}/coupon/applied/update/${appliedCoupanId}/${transactionId}`
        );
        if (response) {
          console.log("Success");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  const Getwallet = async (transactionId) => {
    try {
      let response = await axios.get(
        `${process.env.REACT_APP_API_URL}/user/wallethistory/wallet/${user_id}`
      );
      if (response) {
        setwalletAmount(response.data.amount);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const validateWallet = async (transactionId) => {
    try {
      if (cartAmount == 0) {
        setErrName("Please select test ");
        setErrorPop(true);
        setwalletCodeVisibility(false);
      } else {
        let totalamount = "";
        if (couponAppliedFlag == true) {
          totalamount = discountedAmount;
        } else {
          totalamount = Number(cartAmount).toFixed();
        }
        var payLoad = {
          totalamount: totalamount,
          amount: useAmount,
          user_uuid: user_id,
        };
        let response = await axios.post(
          `${process.env.REACT_APP_API_URL}/user/wallethistory/validateForPay/from/wallet`,
          payLoad
        );
        if (response) {
          setwalletAmount(response.data.remaining_amount);
          setDiscountedAmount(response.data.need_to_pay);
          setwalletFlag(true);
          setwalletCodeVisibility(false);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const walletChange = (event) => {
    setUseamount(event.target.value);
  };
  // console.log(uuid,"uuid")
  // const walletDat = () => {
  //   console.log("WALLET CALLED")
  //   let totalamount = "";
  //     if(couponAppliedFlag == true){
  //       totalamount = discountedAmount
  //     }else{
  //       totalamount = Number(cartAmount).toFixed()
  //     }
  //   var payLoad  = {
  //     "totalamount" : totalamount,
  //     "amount":useAmount,
  //     "order_id" : uuid,
  //     "user_uuid" : user_id
  // }
  //   axios.put(api.updatewalletAmnt,payLoad,{ headers: { "x-auth-token": userdata.token } })
  //   .then((res) => {
  //     console.log("update")
  //   })
  //   .catch((err) => {
  //     console.log(err, "WALLEt ERRORR")
  //   })
  // }
  const PaymentSuccess = async (e, ref, uuid) => {
    try {
      console.log("PaymentSuccess", e, ref, uuid);
      if (couponAppliedFlag === true && discountedAmount === 0) {
        blockAppliedCoupon(ref);
        setCopuponsLoader(true);
        await axios.put(
          `${process.env.REACT_APP_API_URL}/order/cart/cartpayment/${uuid}/paid/${ref}`
        );
        setModalShow(true);
        dispatch(clearCart());
        setCopuponsLoader(false);
      }

      if (e.status === "success") {
        //API for Blocking coupons if applied, do not remove it..
        blockAppliedCoupon(ref);
        if (walletFlag === true) {
          let totalamount = "";
          if (couponAppliedFlag === true) {
            totalamount = discountedAmount;
          } else {
            totalamount = Number(cartAmount).toFixed();
          }
          var payLoad = {
            totalamount: totalamount,
            amount: useAmount,
            order_id: uuid,
            user_uuid: user_id,
          };
          setCopuponsLoader(true);
          await axios.put(
            `${process.env.REACT_APP_API_URL}/user/wallethistory/pay/from/wallet`,
            payLoad,
            { headers: { "x-auth-token": user.token } }
          );
          setCopuponsLoader(false);
        }

        setCopuponsLoader(true);
        await axios.put(
          `${process.env.REACT_APP_API_URL}/order/cart/cartpayment/${uuid}/paid/${ref}`
        );

        setModalShow(true);
        dispatch(clearCart());
        setCopuponsLoader(false);
      } else {
        setCopuponsLoader(true);
        await axios.put(
          `${process.env.REACT_APP_API_URL}/order/cart/cartpayment/${uuid}/unpaid/${ref}`
        );
        setCopuponsLoader(false);
      }
    } catch (e) {
      console.log(e);
      setCopuponsLoader(false);
      if (couponAppliedFlag === true && discountedAmount === 0) {
        blockAppliedCoupon(ref);
        setCopuponsLoader(true);
        await axios.put(
          `${process.env.REACT_APP_API_URL}/order/cart/cartpayment/${uuid}/paid/${ref}`
        );
        setModalShow(true);
        dispatch(clearCart());
        setCopuponsLoader(false);
      }
    }
  };

  const cartFetch = () => {
    setCartAmount(0);
    setShoppingCart([]);
    setDiscountedAmount(0);
    if (cartState.data.fulldetails) {
      setCartUuid(cartState.data.fulldetails[0].uuid);
      setTestItem(cartState.data.fulldetails[0].items);
    }

    if (cartState.data.shoppinglist) {
      if (
        cartState.data &&
        cartState.data.shoppinglist &&
        cartState.data.shoppinglist.length > 0 &&
        cartState.data.shoppinglist[0].type === "package"
      ) {
        setIsPackageCart(true);
      }

      let formData = [];
      cartState.data.shoppinglist.forEach((i) => {
        formData.push({
          show: false,
          addAddress: false,
          allData: false,
          areaid: areaList
            .filter((it) => it.uuid === i.labarea)
            .map((id) => id),
          ...i,
        });
      });

      let addressArray = [];
      cartState.data.shoppinglist.forEach((i) => {
        addressArray.push({
          address: "",
          city: "",
          area: "",
          postCode: "",
          email: "",
          recipient: "",
          phone: "",
        });
      });
      setAddressForm(addressArray);
      setDatatwo(formData);
      setShoppingCart(formData);
    }
    if (cartState.data.homeservice) {
      let homeData = [];
      cartState.data.homeservice.forEach((i) => {
        homeData.push({
          uuid: i.uuidhms,
          labname: i.labnamehms,
          areaname: i.areanamehms,
          patient_uuid: true,
          tests: {
            ogvalue: i.data[0].doctallsexclusivediscountedprice,
            doctallsexclusivediscountedprice:
              i.data[0].doctallsexclusivediscountedprice,
            doctallspurchasingprice: i.data[0].doctallspurchasingprice,
          },
          ogData: i,
        });
      });
      setHomeService(homeData);
      let qty = [];
      cartState.data.homeservice.map((i) => qty.push({ value: 1 }));
      setQtyValue(qty);
    }
  };

  const PartnerUUid = cartState && cartState.data && cartState.data.shoppinglist && cartState.data.shoppinglist[0] &&
    cartState.data.shoppinglist[0].data && cartState.data.shoppinglist[0].data[0] && cartState.data.shoppinglist[0].data[0].partner_uuid;
  // console.log(cartState.data.shoppinglist[0].data[0].partner_uuid,"cartState")
  useEffect(() => {
    let displayTotalAmount = 0;
    if (radiovalue) {
      setPromoCodeVisibility(false);
      let totalValues = radiovalue;
      totalValues &&
        totalValues.map(
          (items) =>{
            // console.log(items, "itemsitems")
            displayTotalAmount += Number(Number(items.cost).toFixed())
          }
          // (displayTotalAmount =
          //   Number(displayTotalAmount) + Number(items.cost))
        );
      setCartAmount(displayTotalAmount);
      console.log(displayTotalAmount,"displayTotalAmount")
      setLoader(false);
    } else {
      setCartAmount(0);
    }
  }, [radiovalue]);

  const homeServicefn = (toCheck) => {
    if (toCheck) {
      setShowHomeService(false);
    } else {
      setShowHomeService(!showHomeService);
    }

    let brdata = [];
    recipientArray.forEach((i) => {
      brdata.push({ name: i.full_name, id: i.uuid });
    });
    setTotalRecipient(brdata);
  };

  const handleRadio = (
    id,
    selectedItem,
    check,
    toCheck,
    isHomeSampleChecked
  ) => {
    setLoader(true);
    let idToCheck = id;
    let duplicateIndex = _.findIndex(radiovalue, function (o) {
      return o.uuid === idToCheck;
    });

    if (duplicateIndex === -1) {
      setRadiovalue((prev) => [...prev, selectedItem]);
    } else {
      var newArray = [...radiovalue]; // make a separate copy of the array
      var index = newArray.indexOf(selectedItem);
      if (index !== -1) {
        newArray.splice(index, 1);
        setRadiovalue(newArray);
      }
    }
  };

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 768
        ? setMobileView(true)
        : setMobileView(false);
    };

    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);

  const handleFormOpen = (index, val, unchecked) => {
    if (homeSerivceData.includes(val) || unchecked) {
      const filteredPeople = homeSerivceData.filter(
        (item) => item.uuid !== val.uuid
      );
      setHomeServiceData(filteredPeople);

      shoppingCart[index].show = false;
    } else {
      setHomeServiceData([...homeSerivceData, val]);
      if (shoppingCart[index].show === false) {
        shoppingCart[index].show = true;
      } else {
        shoppingCart[index].show = false;
      }
    }
  };

  const [showAddAddress, setShowAddAddress] = useState(false);
  const handleInsideForm = (index) => {
    setEdit(false);
    showAddAddress === false
      ? setShowAddAddress(true)
      : setShowAddAddress(false);
  };

  const handleEditForm = (e) => {
    setEditForm({ ...editForm, [e.target.name]: e.target.value });
  };

  const userAuth = useSelector((state) => state.auth);

  const handleCheckout = async () => {
    if (couponAppliedFlag === true && discountedAmount === 0) {
      setCopuponsLoader(true);
    }
    const validate = radiovalue.every((i) => i.patient_uuid);
    const addressValidation = shoppingCart.some((i) => i.show);
    let vaildAddress = radiovalue
      .filter((d) => d.patient_uuid !== true)
      .map((i) => delivery.some((it) => it.patient_uuid === i.patient_uuid));
    vaildAddress = vaildAddress.every((i) => i);

    const homeSampleValidation = radiovalue.every(
      (i) => i.name === "Home Service Charge"
    );

    if (radiovalue.length === 0) {
      setErrName("Please select test to checkout");
      setErrorPop(true);
      return false;
    }

    if (homeSampleValidation === true) {
      setErrName("Please Select Atleast One Test  with Home Service Charge");
      setErrorPop(true);
      return false;
    }

    const bdata = [];
    radiovalue
      .filter((d) => d.patient_uuid !== true)
      .map((i) =>
        bdata.push({
          uuid: i.uuid,
          patient_uuid: i.patient_uuid,
          home_uuid: i.home_service_uuid,
          // rec_test: i.rec_test ? i.rec_test : {}
        })
      );

    // couponAppliedFlag === true && discountedAmount >= 0 ? discountedAmount : cartAmount.toString()

    const formdt = {
      items: bdata,
      amount:
        (couponAppliedFlag || walletFlag) && discountedAmount >= 0
          ? discountedAmount
          : Number(cartAmount),
    };
    console.log(formdt, "formdt");

    await axios
      .put(
        `${process.env.REACT_APP_API_URL}/order/cart/checkout/${cartUuid}`,
        formdt
      )
      .then((res) => {
        setCartCuuid(res.data.cartcheckout.uuid);
        axios
          .post(
            `${process.env.REACT_APP_API_URL}/payment/cart/payment/` +
            res.data.cartcheckout.uuid
          )
          .then((i) => {
            setReference(i.data.reference);
            if (couponAppliedFlag === true && discountedAmount === 0) {
              //Create order here without payment gateway
              PaymentSuccess(
                "100% discount",
                i.data.reference,
                res.data.cartcheckout.uuid
              );
              setModalShow(true);
            } else {
              paymentStart((e) => {
                PaymentSuccess(e, i.data.reference, res.data.cartcheckout.uuid);
              });
            }

            dispatch(clearTest());
          })
          .catch((err) => {
            console.log(err);
            setCopuponsLoader(false);
          });
      })
      .catch((err) => {
        if (err && err.response) {
          setErrorPop(true);
          setErrName("" + err.response.data);
        }
        setCopuponsLoader(false);
      });
  };

  const invalidChar = (e) => {
    (e.key === "e" && e.preventDefault()) ||
      (e.key === "-" && e.preventDefault()) ||
      (e.key === "+" && e.preventDefault());
  };
  const handleQtyValue = (e, index, ind) => {
    let shop = [...shoppingCart];
    shop[ind].show = false;
    setShoppingCart(shop);
    const { value, maxLength } = e.target;
    let vals = value.slice(0, maxLength);
    if (vals <= 0) {
      vals = 1;
      let val = [...qtyValue];
      val[index].value = vals;
      setQtyValue(val);
    } else {
      let val = [...qtyValue];
      val[index].value = e.target.value;
      setQtyValue(val);
      let dt = [...homeService];
      dt[index].tests.doctallsexclusivediscountedprice =
        parseInt(dt[index].tests.ogvalue) * e.target.value;
      setHomeService(dt);
    }
  };

  const handleAllFunction = (index) => {
    let detailData = shoppingCart[index].data;

    //Diffre
    let result = radiovalue.filter((o1) =>
      detailData.some((o2) => o1.uuid === o2.uuid)
    );

    // Remove
    let array1 = detailData.filter((val) => !result.includes(val));
    if (array1.length === 0) {
      let filteredArray = radiovalue.filter((val) => !detailData.includes(val));
      setRadiovalue(filteredArray);
    } else {
      let mergedArray = _.concat(radiovalue, array1);
      setRadiovalue(mergedArray);
    }
  };
  let Amountsss = cartAmount - discountedAmount;
  // walletFlag === true && couponAppliedFlag === true ?
  // setDiscountedAmount()
  return (
    <Layout>
      <Helmet>
        <title>Diagnostic.doctall.com | shopping cart
        </title>
        <meta
          name='description'
          content='Shop for a wide range of tests from Diagnostic Marketplace. Get the best deals, have test results delivered to you'
        />
      </Helmet>
      <div className="shopping-cart-container">
        <div className="header-row">
          {mobileView == false ? (
            <>
              <img src={HomeDisable} alt="HomeDisable" />

              <img src={DisableRight} alt="DisableRight" />
              <div
                className="disable-font"
                onClick={() => {
                  history.push("/populartest");
                }}
                style={{ cursor: "pointer" }}
              >
                Popular Tests
              </div>
              <img src={DisableRight} alt="DisableRight" />
              <div
                className="disable-font"
                onClick={() => {
                  history.push("/compareprice");
                }}
                style={{ cursor: "pointer" }}
              >
                Compare Prices
              </div>
              <img src={DisableRight} alt="DisableRight" />
              <div
                className="disable-font"
                onClick={() => {
                  history.push("/cart-update");
                }}
                style={{ cursor: "pointer" }}
              >
                Add Test Recipients
              </div>
              <img src={Rightnav} alt="Rightnav" />
              <div className="nav-font" style={{ color: "#163E8C" }}>
                Shopping Cart
              </div>
            </>
          ) : (
            <>
              <svg
                width="9"
                height="20"
                viewBox="0 0 9 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => history.goBack()}
              >
                <path
                  d="M8.00019 0.00068029C8.12412 0.000680294 8.24805 0.0481132 8.34258 0.142645C8.53164 0.331708 8.53164 0.638352 8.34258 0.827749L1.16986 8.0008L5.93753 12.7688C6.12659 12.9579 6.12659 13.2645 5.93753 13.4539C5.74847 13.643 5.44182 13.643 5.25243 13.4539L0.142038 8.34352C-0.0470249 8.15445 -0.0470249 7.84781 0.142038 7.65841L7.65747 0.142645C7.75234 0.0481131 7.87627 0.000680286 8.00019 0.00068029Z"
                  fill="#163E8C"
                />
              </svg>

              <div className="nav-font" onClick={() => history.goBack()}>
                Back
              </div>
            </>
          )}
        </div>
        <div className="wrapper-cls">
          <div className="left-container">
            <div className="headers-cls" style={{maxWidth:"1040px"}}>
              <div className="header-font">Shopping Cart</div>
              {!mobileView ? (
                <div
                  className="back-cont-out"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    history.push("/populartest");
                  }}
                >
                  {<span>GO BACK TO SHOPPING </span>}
                </div>
              ) : (
                <>
                  <div
                    className="back-cont-out"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push("/populartest");
                    }}
                  >
                    {<span>GO BACK TO SHOPPING </span>}
                  </div>
                </>
              )}
            </div>

            <div className="top-divider"></div>
            <div className="shop-cart-out">
              <div className="shopping-cart-outer-container">
                <div className="header-container-top">
                  <div className="font-cls">Diagnostic Test</div>
                </div>
                {shoppingCart !== undefined || shoppingCart.length > 0 ? (
                  shoppingCart.map((i, index) => {
                    if (isPackageCart) {
                      return (
                        <ShoppingCartPackageLabWise
                          item={i}
                          key={index}
                          index={index}
                          // mobileView={mobileView}
                          radiovalue={radiovalue}
                          homeServicefn={homeServicefn}
                          showHomeService={showHomeService}
                          handleRadio={handleRadio}
                          homeService={homeService}
                          datatwo={datatwo}
                          qtyValue={qtyValue}
                          handleAllFunction={handleAllFunction}
                          invalidChar={invalidChar}
                          handleFormOpen={handleFormOpen}
                          handleQtyValue={handleQtyValue}
                          handleInsideForm={handleInsideForm}
                          addHomeAddress={(address) => setHomeAddress(address)}
                        />
                      );
                    } else {
                      return (
                        <ShoppingCartLabWise
                          i={i}
                          key={index}
                          index={index}
                          // mobileView={mobileView}
                          radiovalue={radiovalue}
                          homeServicefn={homeServicefn}
                          showHomeService={showHomeService}
                          handleRadio={handleRadio}
                          homeService={homeService}
                          datatwo={datatwo}
                          qtyValue={qtyValue}
                          handleAllFunction={handleAllFunction}
                          invalidChar={invalidChar}
                          handleFormOpen={handleFormOpen}
                          handleQtyValue={handleQtyValue}
                          handleInsideForm={handleInsideForm}
                          addHomeAddress={(address) => setHomeAddress(address)}
                        />
                      );
                    }
                  })
                ) : (
                  <CircularProgress />
                )}
              </div>
            </div>
          </div>

          <div className="right-cont-out">
            <div className="right-container">
              <div className="header-out">
                <div className="header-font">Selected Order Summary</div>
              </div>
              <div className="mid-container">
                <div className="subtotal-row">
                  <div className="left-font">Subtotal</div>
                  <div className="right-font">
                    ₦{Number(cartAmount).toFixed()}
                  </div>
                </div>
                <div
                  className="coupon-font"
                  onClick={() => {
                    setPromoCodeVisibility(!promoCodeVisibility);
                    setCouponsAppliedFlag(false);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  Have a Promo Code ?
                </div>
              </div>
              {promoCodeVisibility && (
                <div
                  style={{
                    marginTop: "3%",
                    marginBottom: "3%",
                    marginLeft: "1%",
                  }}
                >
                  <ApplyPromoCode
                    totalAmount={cartAmount}
                    close={() => {
                      setPromoCodeVisibility(!promoCodeVisibility);
                    }}
                    finalAmount={(amount) => {
                      setDiscountedAmount(Number(amount));
                    }}
                    walletAppliedFlags={walletFlag}
                    amnt={useAmount}
                    couponAppliedFlags={(event) => {
                      setCouponsAppliedFlag(event);
                    }}
                    blockCouponid={(couponId) => {
                      setAppliedCoupanId(couponId);
                    }}
                    PartnerUUid={PartnerUUid}
                  />
                </div>
              )}
              <div>&nbsp;</div>
              <div
                className="coupon-font"
                style={{
                  cursor: "pointer",
                  marginLeft: "8%",
                  color: "#0c44ac",
                  fontWeight: "400",
                  fontSize: "20px",
                }}
              >
                You currently have ₦{walletamount}
                <br></br> in your wallet balance{" "}
                <b
                  onClick={() => {
                    setwalletCodeVisibility(!walletCodeVisibility);
                    setwalletFlag(false);
                  }}
                  style={{ color: "blue" }}
                >
                  <u>Click here</u>
                </b>{" "}
                to use !
              </div>
              {walletCodeVisibility && (
                <div
                  style={{
                    marginTop: "3%",
                    marginBottom: "3%",
                    marginLeft: "1%",
                  }}
                >
                  {/* <ApplyPromoCode
                    totalAmount={cartAmount}
                    close={() => {
                      setPromoCodeVisibility(!promoCodeVisibility);
                    }}
                    finalAmount={(amount) => {
                      setDiscountedAmount(Number(amount));
                    }}
                    couponAppliedFlags={(event) => {
                      setCouponsAppliedFlag(event);
                    }}
                    blockCouponid={(couponId) => {
                      setAppliedCoupanId(couponId);
                    }}
                  /> */}
                  <input
                    style={{ marginLeft: "8%" }}
                    onChange={(event) => walletChange(event)}
                  ></input>{" "}
                  <button
                    style={{
                      border: "1px solid blue",
                      backgroundColor: "blue",
                      borderRadius: "5px",
                      color: "#fff",
                    }}
                    onClick={validateWallet}
                  >
                    Submit
                  </button>{" "}
                </div>
              )}
              {
                walletFlag == true && (
                  // <div className={"input"}>
                  <div style={{ marginLeft: "8%" }}>
                    <div>&nbsp;</div>
                    <div className="info-text" style={{ color: "#6c6f78" }}>
                      {`You have succefully claimed ₦${useAmount} from your wallet`}
                    </div>
                  </div>
                )
                // </div>
              }
              <div className="divider"></div>

              <div className="total-row">
                <div
                  className="left-cont"
                  style={{ fontFamily: "visuelt-regular" }}
                >
                  Total
                </div>
                <div className="right-cont">
                  ₦{Number(cartAmount).toFixed()}
                </div>
              </div>
              {(walletFlag === true || couponAppliedFlag === true) &&
                discountedAmount >= 0 && (
                  <div className="total-row">
                    <div className="left-cont">Discounted Amount</div>
                    <div className="right-cont">
                      ₦{Number(Amountsss).toFixed()}
                    </div>
                  </div>
                )}
              {(walletFlag === true || couponAppliedFlag === true) &&
                discountedAmount >= 0 && (
                  <div className="total-row">
                    <div className="left-cont">Amount to pay</div>
                    <div className="right-cont">
                      ₦{Number(discountedAmount).toFixed()}
                    </div>
                  </div>
                )}
              {/* {
                ((walletFlag === true || couponAppliedFlag === true) && discountedAmount >= 0) ? 
                <div className="total-row">
                <div className="left-cont">Amount to pay</div>
                <div className="right-cont">₦{Number(discountedAmount).toFixed()}</div>
              </div>
                :
                ((walletFlag === true && couponAppliedFlag === true) && discountedAmount >= 0) && 
                <div className="total-row">
                <div className="left-cont">Amount to pay</div>
                <div className="right-cont">₦{Number(discountedAmount).toFixed()}</div>
              </div>
              } */}

              <div
                className={"checkout-btn"}
                onClick={() => {
                  handleCheckout();
                }}
              >
                <span>Proceed to Payment</span>
                {/* <span>Proceed</span> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <CheckoutSuccess
        show={modalShow}
        onHide={() => setModalShow(false)}
      // handleConfirmChangePass={handleConfirmChangePass}
      />
      <Toast
        text={errName}
        type="warning"
        open={errorPop}
        setClose={() => {
          setErrorPop(false);
        }}
      />
      <Toast
        text={successName}
        type="success"
        open={successPop}
        setClose={() => {
          setSuccessPop(false);
        }}
      />

      {copuponsLoader === true && <LoaderComponent />}

      <button className="fixedButton" onClick={handleButtonClick}>

        <svg xmlns="http://www.w3.org/2000/svg" height="2em" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16" id="IconChangeColor"> <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" id="mainIconPathAttribute" fill="#ffffff"></path> </svg>
      </button>

      {/* Popup */}
      {showPopup && (
        <div className="popup">
          <p>We're here to assist you! If you have any difficulties finding tests, locating a lab, or have any questions, feel free to reach out to us on WhatsApp at <span style={{ cursor: "grab", fontWeight: "bold", color: "#ff5c3c" }}>+2349010996000</span>. Our team is ready to help you find the right diagnostic solutions and ensure a smooth experience.</p>
          <button className="popupButton" onClick={closePopup}>Close</button>
        </div>
      )}

    </Layout>
  );
};

export default ShoppingCart;
